/** @format */

import AnimationMySelogerProSvg from "@local/icons/component/Animation/AnimationMySelogerPro"
import styled from "styled-components"

type ContainerProps = {
	opacity: number
	transitionMs: number
	isSticky: boolean
}
export const Container = styled.div<ContainerProps>`
	z-index: 9999;
	position: ${props => (props.isSticky ? "sticky" : "fixed")};
	height: ${props => (props.isSticky ? "100vh" : "100%")};
	width: ${props => (props.isSticky ? "100%" : "auto")};
	display: flex;
	align-items: center;
	justify-content: center;
	background: rgba(255, 255, 255, 0.8);
	transition: opacity ${props => props.transitionMs}ms;
	opacity: ${props => props.opacity};
	top: 0;
	bottom: ${props => (props.isSticky ? "auto" : 0)};
	left: 0;
	right: ${props => (props.isSticky ? "auto" : 0)};
`

export const AnimationMySelogerPro = styled(AnimationMySelogerProSvg)`
	width: 204px;
	position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
`
